import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ImageService } from './shared/services/image.service';
import { IconsService } from './shared/services/icons.service';
import { AppCheckService } from './services/app-check.service';
import { SecureStorageService } from './services/secure-storage.service';

@Component({
  selector: 'app-root',
  template: `
    <app-navbar *ngIf="user" [user]="user" [profileLogo]="profileLogo"></app-navbar>
    <div class="d-flex clearfix">
      <div class="d-none d-sm-none d-md-block">
        <app-sidebar *ngIf="user" [user]="user" [profile]="profile" [profileLogo]="profileLogo"></app-sidebar>
      </div>
      <div class="main-container flex-fill mx-3 my-5 m-md-3 mb-0" role="main" (window:resize)="onResize($event)">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-notify-floater></app-notify-floater>
  `,
  styleUrls: []
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;
  private apiUrl: string = environment.AWS_REST_WSPREFIX;
  protected version = environment.app_version;

  ux: any = null;
  user: any = null;
  profile: any = null;
  profiles: any = [];
  role: any = {};
  permissions: any = {};
  profileLogo: any = '';
  school: any = {};

  superadmin: boolean = false;
  avatarURL: string = '';
  avatarLS: any = null;

  captchaResponse: string = '';

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private imgService: ImageService,
    public icons: IconsService,
    private appCheck: AppCheckService,
    private secureStorage: SecureStorageService
  ) {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.initializeUserData();
      }
    });
  }

  private async initializeUserData() {
    try {
      // Get user data from encrypted storage
      this.ux = await this.secureStorage.getItem('user');
      this.user = this.ux ? JSON.parse(this.ux) : null;
      
      // Get other data from encrypted storage
      const schoolData = await this.secureStorage.getItem('school');
      this.school = schoolData ? JSON.parse(schoolData) : null;
      
      const profileData = await this.secureStorage.getItem('profile');
      this.profile = profileData ? JSON.parse(profileData).profile : null;
      
      const roleData = await this.secureStorage.getItem('role');
      this.role = roleData ? JSON.parse(roleData).role : null;
      
      const permissionsData = await this.secureStorage.getItem('permissions');
      this.permissions = permissionsData ? JSON.parse(permissionsData) : {};
      
      this.superadmin = this.role?.id === 1;

      if (this.profile) {
        this.profileLogo = this.profile.logo ? this.imgService.buildURL(this.profile.logo) : 'assets/images/logo-zazz.png';
        if (!this.avatarLS) {
          // Avatar logic would go here if needed
        } else {
          const avatarData = await this.secureStorage.getItem('avatar');
          this.avatarLS = avatarData ? JSON.parse(avatarData) : {};
        }
      }
    } catch (error) {
      console.error('Error loading user data from encrypted storage:', error);
      // Fallback to null values
      this.user = null;
      this.school = null;
      this.profile = null;
      this.role = null;
      this.permissions = {};
    }
  }

  ngOnInit(): void {
    this.initializeUserData();
    
    console.info(`
        ESCALAS
   @@@@@@@@@@@@@@@@@@ 
  @@=--------------=@@
  @#----+******+----#@
  @#---+@+====+@=---#@
  @#---+@==%%%@@=---#@
  @#---+@=====+@=---#@
  @#---+@==%@@@@=---#@
  @#---+@======@+---#@
  @#----+******+----#@
  @@=--------------=@@
   @@@@@@@@@@@@@@@@@@ 
        `);
  }

  onResize(event: any) {}

  changeProfile(profile: any) {
    this.profile = profile;
    let currProfile = this.profiles.find((el: any) => profile.id == el.id);
    localStorage.setItem('profile', JSON.stringify({ profile: currProfile}));   
  }

  signOut() {
    try {
      this.secureStorage.removeItem('token');
      this.secureStorage.removeItem('user');
      this.secureStorage.removeItem('profile');
      this.secureStorage.removeItem('avatar');
      this.secureStorage.removeItem('permissions');
      this.secureStorage.removeItem('role');
      this.router.navigate(['sign-in']);
    } catch (error) {
      console.error('Error during sign out:', error);
      // Force navigation anyway
      this.router.navigate(['sign-in']);
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

}
